import { REMOVE_TARGET, REMOVE_SOURCE, ADD_TARGET, ADD_SOURCE } from '../actions/924e2c35d164e222a46ac0f398ff0d07c648c8824560ac57471f964ea7c90e91.cfe-internal.js';

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;
    default:
      return state;
  }
}

export { reduce };
